import AuthGuardDisplay from '@components/AuthGuardDisplay';
import Column from '@components/Column';
import Header from '@components/Header';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import AccountFooter from './components/AccountFooter';
import AccountManagement from './components/AccountManagement';
import Permissions from './components/Permissions';
import Policies from './components/Policies';

declare module '@stackflow/config' {
    interface Register {
        AccountSettingActivity: {};
    }
}

const AccountSettingActivity: ActivityComponentType<'AccountSettingActivity'> = () => {
    const { t } = useTranslation('accountSetting');
    return (
        <AppScreen>
            <Header title={t('header.title')} />
            <Container as='main' spacing={10}>
                <Column fullWidth as='section'>
                    <AuthGuardDisplay>
                        <AccountManagement/>
                        <Permissions/>
                    </AuthGuardDisplay>
                    <Policies/>
                </Column>
                <AccountFooter/>
            </Container>
        </AppScreen>
    );
};

const Container = styled(Column)`
    padding-top: var(--spacing-0-5);
`;

export default AccountSettingActivity;
